import { render, staticRenderFns } from "./Mytestpaper.vue?vue&type=template&id=384a220b&scoped=true"
import script from "./Mytestpaper.vue?vue&type=script&lang=js"
export * from "./Mytestpaper.vue?vue&type=script&lang=js"
import style0 from "./Mytestpaper.vue?vue&type=style&index=0&id=384a220b&prod&lang=less"
import style1 from "./Mytestpaper.vue?vue&type=style&index=1&id=384a220b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384a220b",
  null
  
)

export default component.exports